export const withLeadingHashPrefix = (hash?: string) => {
  if (!hash) return "";
  return hash.startsWith("#") ? hash : `#${hash}`;
};
